import type { ReactNode } from "react";

type Props = {
	/** Display numeral, e.g. `01` / `02`. */
	children: ReactNode;
	className?: string;
};

/**
 * Serif-numbered step mark (homepage How it works pattern).
 * Decorative — pair with a visible heading; `aria-hidden` by default.
 * Layout: two-column grid, numeral ~36px, content flexible, column-gap 20px, row-gap 28px.
 */
export function SequenceNumeral({ children, className = "" }: Props) {
	return (
		<span
			className={[
				"wi-type-h2 w-9 shrink-0 tabular-nums text-[20px] leading-none text-wi-gold",
				className,
			]
				.filter(Boolean)
				.join(" ")}
			aria-hidden="true"
		>
			{children}
		</span>
	);
}
